import moment from 'moment';

function moneyFormat(value) {
  if (value) {
    return String(value).replace('.', ',');
  }
  return 'N/I';
}

/* eslint-disable quote-props */
const ProcessesReportColumnsExcel = {
  'Ref Prime': {
    fieldFilter: 'identification',
    callback: (value) => {
      let typeOfProcess = '';
      switch (value.typeOfProcess) {
        case 'CONTA_E_ORDEM':
          typeOfProcess = 'PRI';
          break;
        case 'ENCOMENDA':
          typeOfProcess = 'E';
          break;
        case 'ASSESSORIA':
          typeOfProcess = 'A';
          break;
        default:
          typeOfProcess = 'PRI';
          break;
      }
      return `${typeOfProcess}${String(value.identification).padStart(5, '0')}`
    },
  },
  'Etapa': {
    fieldFilter: 'step.description',
    field: 'step.description',
  },
  'Empresa': {
    fieldFilter: 'customer.name',
    field: 'customer.name',
  },
  'Exportador': {
    fieldFilter: 'exporter.name',
    field: 'exporter.name',
  },
  'Ref Pedido': {
    fieldFilter: 'customerRef',
    field: 'customerRef',
  },
  'Outras Referencias': {
    fieldFilter: 'anotherRef',
    field: 'anotherRef',
  },
  'Status': {
    fieldFilter: 'status',
    field: 'status',
  },
  'Invoice': {
    fieldFilter: 'invoice',
    field: 'invoice',
  },
  'Moeda': {
    fieldFilter: 'cifValueCurrency',
    field: 'cifValueCurrency',
  },
  'Via de Transporte': {
    fieldFilter: 'wayOfTransport',
    field: 'wayOfTransport',
  },
  'Incoterm': {
    fieldFilter: 'incoterm',
    field: 'incoterm',
  },
  'Forwarder': {
    fieldFilter: 'freightForwarder.name',
    field: 'freightForwarder.name',
  },
  'CNTR': {
    fieldFilter: 'typeOfBoarding',
    field: 'typeOfBoarding',
  },
  'Data de Abertura': {
    fieldFilter: 'created',
    field: 'created',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Previsão da Prontidão de Carga': {
    fieldFilter: 'datesEstimatedGoodsReadinesDate',
    field: 'datesEstimatedGoodsReadinesDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETD': {
    fieldFilter: 'datesETD',
    field: 'datesETD',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETA': {
    fieldFilter: 'datesETA',
    field: 'datesETA',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Entrega Cliente (Prevista)': {
    fieldFilter: 'datesEstimatedCustomerDeliverDate',
    field: 'datesEstimatedCustomerDeliverDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Previsão de Numerário':{
    fieldFilter: 'estimatedStepCashRequest',
    field: 'estimatedStepCashRequest',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Prontidão de Carga':{
    fieldFilter: 'datesGoodsReadinesDate',
    field: 'datesGoodsReadinesDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Coleta':{
    fieldFilter: 'datesCargoCollectDate',
    field: 'datesCargoCollectDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Embarque': {
    fieldFilter: 'datesDepartureDate',
    field: 'datesDepartureDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Chegada': {
    fieldFilter: 'datesArrivalDate',
    field: 'datesArrivalDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Nº DI / DUIMP': {
    fieldFilter: 'diNumber',
    callback: (value) => {
      if (!value.duimp) {
        return value.diNumber || 'N/I';
      }
      return value.duimpIdentification || 'N/I';
    },
  },
  'Versão DUIMP': {
    fieldFilter: 'duimpVersion',
    callback: (value) => {
      if (value.duimp) {
        return value.duimpVersion || 'N/I';
      }
      return 'N/I';
    },
  },
  'Chave DUIMP': {
    fieldFilter: 'duimpAccessKey',
    callback: (value) => {
      return value.duimpAccessKey || 'N/I';
    },
  },
  'Nº do Protocolo': {
    fieldFilter: 'diProtocol',
    callback: (value) => {
      if (!value.duimp) {
        return value.diProtocol || 'N/I';
      }
      return 'N/I';
    },
  },
  'Registro': {
    fieldFilter: 'diRegistryDate',
    callback: (value) => {
      if (!value.duimp) {
        return `${value.diRegistryDate ? moment(value.diRegistryDate).format('DD/MM/YYYY') : 'N/I'}`;
      }
      return `${value.duimpRegistryDate ? moment(value.duimpRegistryDate).format('DD/MM/YYYY') : 'N/I'}`;
    },
  },
  'Data de Desembaraço': {
    fieldFilter: 'diResourcefulnessDate',
    callback: (value) => {
      if (!value.duimp) {
        return `${value.diResourcefulnessDate ? moment(value.diResourcefulnessDate).format('DD/MM/YYYY') : 'N/I'}`;
      }
      return `${value.duimpResourcefulnessDate ? moment(value.duimpResourcefulnessDate).format('DD/MM/YYYY') : 'N/I'}`;
    },
  },
  'Canal': {
    fieldFilter: 'diChannel',
    callback: (value) => {
      if (!value.duimp) {
        return value.diChannel || 'N/I';
      }
      return value.duimpChannel || 'N/I';
    },
  },
  'Carregamento': {
    fieldFilter: 'datesGoodsLoadingDate',
    field: 'datesGoodsLoadingDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Entrega no Cliente': {
    fieldFilter: 'datesCustomerDeliverDate',
    field: 'datesCustomerDeliverDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Valor CIF': {
    fieldFilter: 'cifValue',
    field: 'cifValue',
    callback: (value) => `${moneyFormat(value)}`,
  },
};

export const CalendarColumnsExcel = {
  'Ref': 'identification',
  'Etapa': 'step.description',
  'Empresa': 'customerName',
  'Exportador': 'exporterName',
  'Ref Pedido': 'customerRef',
  'Invoice': 'invoice',
  'Incoterm': 'incoterm',
  'Entrega Cliente (Prevista)': {
    field: 'datesEstimatedCustomerDeliverDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Prodidão Prevista': {
    field: 'datesEstimatedGoodsReadinesDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETD': {
    field: 'datesETD',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETA': {
    field: 'datesETA',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Tipo': {
    field: 'type',
  },
  'Vencimento': {
    field: 'itemDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Valor Numerário': {
    field: 'stepCashRequestEstimatedValue',
    callback: (value) => `${moneyFormat(value)}`,
  },
  'Valor Numerário Prev': {
    field: 'estimatedStepCashRequestEstimatedValue',
    callback: (value) => `${moneyFormat(value)}`,
  },
  'Parcela da Invoice (R$)': {
    field: 'installmentInBrl',
    callback: (value) => `${moneyFormat(value)}`,
  },
  'Parcela da Invoice na Moeda': {
    field: 'installment',
    callback: (value) => `${moneyFormat(value)}`,
  },
  'Moeda da Invoice': {
    field: 'currency',
  },
  'Docs enviados p/ câmbio': {
    field: 'documentsSentForExchange',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
};

export default ProcessesReportColumnsExcel;
